import { DesktopSortSelector } from './components/DesktopSortSelector';
import { MobileSortSelector } from './components/MobileSortSelector';
import { useSortSelector } from './hooks/useSortSelector';

type SortSelectorProps = {
	desktopView: boolean;
};

export const SortSelector: React.FC<SortSelectorProps> = ({ desktopView }) => {
	const {
		data: { options, currentRefinement, sortByTitle, currentLabel },
		actions: { changeSelection },
	} = useSortSelector();
	if (desktopView)
		return (
			<DesktopSortSelector
				currentRefinement={currentRefinement}
				currentLabel={currentLabel}
				sortByTitle={sortByTitle}
				options={options}
				changeSelection={changeSelection}
			/>
		);
	return (
		<MobileSortSelector
			currentRefinement={currentRefinement}
			currentLabel={currentLabel}
			sortByTitle={sortByTitle}
			options={options}
			changeSelection={changeSelection}
		/>
	);
};
